import React, { Component } from 'react'
import './index.scss'
import ScrollBar from '../../../../../../Packages/ScrollBar';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { getPriorityListStaticIds, isDragHandleNeeded } from './helper';
import parse from "html-react-parser";
import { TEXT_SECTION, TEXT_SECTION_180_SELF } from './constants';
import ErrorBlock from '../ErrorBlock';
import SVGIcons from '../../../../../../Components/SVGIcons';
import { KEY_CONSTANTS } from '../../constants';
import { FEEDBACK_360_SURVEY } from '../../../../../../../config/questionTypeConstants';

export default class FeedBackRanking extends Component {
    constructor(props) {
        super(props);
    }
    componentDidMount(){
      this.props.behaviourDragUpdate()
    }
  renderAnsweredQuestions = (answeredQuestionDetails, questionCount) => {
    let priorityAddedIds = this.props.questionDetails.questions && this.props.questionDetails.questions.length > 0 ? getPriorityListStaticIds(this.props.questionDetails.questions[0].answer) : []
        return (
          <div className='feedbackDrak__left'>
            <h3>Total Behaviors: {questionCount} </h3>
            {answeredQuestionDetails && Object.keys(answeredQuestionDetails).map((answeredColumnObject, key) => (

              <>
                {!isNaN((parseInt(answeredColumnObject))) && (
                  <div className='feedbackDrak__left--area' key={key}>
                      <Droppable droppableId={answeredQuestionDetails[answeredColumnObject].answerLabel} key={answeredQuestionDetails[answeredColumnObject].answerLabel}>
                        {(provided) => (
                          <div
                            id={answeredQuestionDetails[answeredColumnObject].answerLabel}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                       
                          >
                            <h4>{answeredQuestionDetails[answeredColumnObject].answerLabel}</h4>
                            {answeredQuestionDetails[answeredColumnObject] && answeredQuestionDetails[answeredColumnObject].questions && answeredQuestionDetails[answeredColumnObject].questions.map((questionDetails, index) => (
                              <>
                                {!priorityAddedIds.includes(questionDetails.id) && (
                                  < Draggable key={JSON.stringify(questionDetails)} draggableId={JSON.stringify(questionDetails)} index={index}>
                                    {(provided) => (
                                      <div
                                        // className={style.pairingArea}
                                        {...provided.draggableProps}
                                        ref={provided.innerRef}
                                      >
                                        <div
                                          {...provided.dragHandleProps}
                                          className='feedbackbox'
                                        >
                                          {questionDetails.question}
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                )}
                              </>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                  </div>
                    )}
                  </>

            ))}
          </div>
        );
      };
      

    dragEnd = (event) => {
      if (event.destination && isDragHandleNeeded(event)) {
            this.props.handleDragEndPriority({ blockId: this.props.questionDetails.blockId, destinationDetails: event.destination, sourceDetails: JSON.parse(event.draggableId) })
        }

    }

  renderDropZone = (questionCount) => {
        let currentDetails = this.props.questionDetails
    let rankingCount = currentDetails.totalRanking
    let droppableArray = Array.from({ length: rankingCount }, (_, i) => {
            return ({
                label: i + 1
            })
        })
        return (
            <>
                <div className='feedbackDrak__right'>
                  <h3>DRAG AND DROP THE BEHAVIORS YOU WANT TO PRIORITIZE</h3>
                    {droppableArray.map((item, key) => {
                      let answer = currentDetails.questions.length > 0 && currentDetails.questions[0].answer ? JSON.parse(currentDetails.questions[0].answer).find((answer) => answer.answer === item.label.toString()) : undefined
                        return (
                            <>
                                <Droppable droppableId={JSON.stringify({ id: item.label })} key={key} >
                                    {(provided) => (
                                        <div
                                            id={key}
                                            {...provided.droppableProps}
                                            ref={provided.innerRef}
                                          
                                        >
                                            <div className='feedbackDrak__right--area'>
                                                {answer ? (
                                                    <>
                                                        <span>{answer.question}</span>
                                                        <span className='delete-icon' onClick={() => this.handleDeleteItem(key, item, answer)}>
                                                            <SVGIcons type={'SVG-delete'} />
                                                        </span>
                                                    </>
                                                ) : (
                                                    <span>{item.label}</span>
                                                )}
                                            </div>                                         
                                            {/* {provided.placeholder} */}
                                        </div>)}
                                </Droppable>
                            </>
                        )

                    })}
                </div>
            </>

        )
    }

    handleDeleteItem = (index, item, selectedAnswer) => {
      this.props.handleBehaviourDragDelete({selectedAnswer,index,item,blockId:this.props.questionDetails.blockId})
  }
  
  render() {
    let answeredQuestionDetails = this.props.questionDetails.questions[0];
    let questionCount = 0
    if (answeredQuestionDetails) {
      for (const key in answeredQuestionDetails) {
        if (answeredQuestionDetails[key].questions && Array.isArray(answeredQuestionDetails[key].questions)) {
          questionCount += answeredQuestionDetails[key].questions.length;
        }
      }

    }
        return (
          <>
            <div className='feedbackArea'>
                  {this.props.surveyQuestionSetData.projectType === FEEDBACK_360_SURVEY.DYNAMIC_180 ?
              (this.props.relation === KEY_CONSTANTS.SELF ?
                parse(TEXT_SECTION_180_SELF[this.props.questionDetails.goalId]) :
                parse(TEXT_SECTION[this.props.questionDetails.goalId])
              ) :
              parse(TEXT_SECTION[this.props.questionDetails.goalId])
                }
            </div>
            <div className='feedbackDrak'>
                <DragDropContext onDragEnd={this.dragEnd} onDragUpdate={this.dragUpdates}>
                {this.renderAnsweredQuestions(answeredQuestionDetails, questionCount)}
                {this.renderDropZone(questionCount)}
                </DragDropContext>
            </div>
            <ErrorBlock manageScroller={this.props.manageScroller} />
          </>
        )
    }
}
